import facebook from './facebook-svg'
import instagram from './instagram-svg'
import linkedIn from './linkedIn-svg'
import twitter from './twitter-svg'

export default {
    facebook,
    instagram,
    linkedIn,
    twitter,
}
